<template>
    <v-autocomplete
        outlined
        dense
        ref="autocomplit"
        auto-select-first
        chips
        small-chips
        :rules="rules"
        :item-disabled="disabledFunc"
        hide-details
        no-data-text="Данные отсутствуют, что бы добавить новое значение начните вводить его..."
        @input="updateInput"
        :multiple="multiple"
        :items="itemsList"
        :item-text="itemText"
        :item-value="itemValue"
        :disabled="disabled"
        :value="value"
        :label="label"
        :color="color"
        :clearable="clearable"
        style="width: 350px;"
    >
        <template v-slot:prepend-item>
            <v-list-item v-if="$refs.autocomplit && $refs.autocomplit.lazySearch && $refs.autocomplit.lazySearch.length > 0">
                <v-list-item-title>
                    <v-btn small @click.prevent.stop="save('autocomplit')">+ Добавить значение</v-btn>
                </v-list-item-title>
            </v-list-item>
        </template>

        <template v-slot:selection="{ item }">
            <v-chip small>
                <span>{{ item.name }}</span>
            </v-chip>
        </template>

        <template v-slot:item="{ item, attrs }">
            <v-checkbox class="mt-0 pt-0" hide-details v-model="attrs.inputValue" />
            {{ item.name }}
        </template>
    </v-autocomplete>
</template>

<script>
export default {
	name: 'Select',
	props: {
        label: String,
		url: String,
		disabled: Boolean,
		clearable: Boolean,
		multiple: Boolean,
        itemText: String,
        itemValue: String,
		items: {
            type: Array,
            default: () => []
        },
		value: [Array, String, Number, Boolean],
        selectedParent: {
            type: Array,
            default: () => []
        },
		color: String,
        rules: Array
	},
    data: () => ({
        params: '',
        itemsList: []
    }),
	methods: {
		updateInput(event) {
			this.$emit('input', event);
		},
        save(name) {
            if(this.itemsList.length > 0) {
                let success = true;

                for (let i = 0; i < this.itemsList.length; i++) {
                    if(String(this.itemsList[i].name).toLocaleLowerCase() === String(this.$refs[name].lazySearch).toLocaleLowerCase()) {
                        success = false
                        break;
                    }
                }

                if(success) {
                    this.$emit('saveParams', this.$refs[name].lazySearch);
                    this.$nextTick(() => { this.$refs[name].lazySearch = ''; })
                } else {
                    this.$emit('snackBar', true, 'Ошибка, название значения не должно повторяться!', 'warning');
                }
            } else {
                this.$emit('saveParams', this.$refs[name].lazySearch);
                this.$nextTick(() => { this.$refs[name].lazySearch = ''; })
            }
        },
        disabledFunc(obj) {
            if(this.selectedParent && this.selectedParent.length > 0) {
                for (let i = 0; i < this.selectedParent.length; i++) {
                    if(obj.id === this.selectedParent[i]) return true
                }
            }
        }
	},
    created() {
        this.itemsList = this.items;

        if(this.selectedParent.length > 0) {
            for (let i = 0; i < this.itemsList.length; i++) {
                this.itemsList[i].disabled = false;
            }
        }
    }
}
</script>
<style scoped>
.v-btn{
        padding: 6px 12px;
        border-radius: 8px;
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        white-space: nowrap;
        border: 2px solid #4854FE;
        color: #4854FE !important;
    text-transform: initial;
}
</style>